import { DashboardFilterName, DashboardFilterType } from '@vi-iot/client';

import { DashboardFilter } from '@store';

export interface KanbanComplexFilterList {
  type: DashboardFilterType;
  filterName: DashboardFilterName;
  filters: DashboardFilter[];
}

export enum LinkID {
  list = 'list',
  board = 'board',
  map = 'map',
}

export interface Link {
  linkID: LinkID;
  link: string;
  label: string;
}
